interface LockedPlaceholderProps {
  sectionName: string;
  onNavigate: () => void;
}

export default function LockedPlaceholder({ sectionName, onNavigate }: LockedPlaceholderProps) {
  return (
    <div className="relative min-h-[400px]">
      {/* Blurred background to suggest content */}
      <div className="filter blur-sm pointer-events-none opacity-40">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 rounded-xl p-6 h-32"></div>
          <div className="bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/30 dark:to-green-800/30 rounded-xl p-6 h-32"></div>
          <div className="bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/30 dark:to-purple-800/30 rounded-xl p-6 h-32"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800/30 dark:to-gray-700/30 rounded-xl p-6 h-48"></div>
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800/30 dark:to-gray-700/30 rounded-xl p-6 h-48"></div>
        </div>
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-white dark:bg-gray-800 rounded-xl p-8 shadow-2xl border border-gray-200 dark:border-gray-700 max-w-md w-full mx-4 text-center">
          <div className="w-16 h-16 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-lock-line text-3xl text-gray-500 dark:text-gray-400"></i>
          </div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
            Lock your keyword universe to see {sectionName}
          </h3>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Your keyword strategy forms the foundation for all downstream analysis. Finalize your keyword selection first.
          </p>
          <button
            onClick={onNavigate}
            className="px-6 py-3 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-lg font-semibold hover:from-teal-600 hover:to-emerald-600 transition-all duration-300 flex items-center justify-center space-x-2 mx-auto"
          >
            <span>Open Utility Manager</span>
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
